import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel, faBuilding, faMapMarkerAlt, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import Filter from '../../CardFilter';
import Pagination from '../../CardPagination';
import { staffRoleFormatter } from '../../../lib/formatter';

const HotelList = ({
  hotelListTotal,
  hotelListItems,
  filterItem,
  paginationItem,
  listHotelApi,
  selectedHotel,
  setFilterItem,
  setPaginationItem,
  setIsDebounce,
  history,
}) => {
  const { t } = useTranslation();
  const [ currentPageNumber, setCurrentPageNumber ] = useState(1);

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  const changeFilterItem = (targetItem) => {
    setFilterItem({
      ...filterItem,
      ...targetItem,
    });
    //디바운싱 사용 구분을 위해 setIsDebounce에 true를 고정으로 넣어줌
    setIsDebounce(true);
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const initFilterItem = () => {
    setFilterItem({
      name: '',
    });
    //클린은 디바운싱 사용을 안 하기 때문에 false
    setIsDebounce(false);
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const selectHotel = async (hotelId) => {
    try {
      await selectedHotel(hotelId);
      return history.push('/booking');
    } catch (error) {
      return;
    }
  };

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>{t('content_title.hotel_list')}</h3>
      </div>
      <div className='content-title'>
        <Filter
          columns={[
            {
              key: 'name',
              type: 'text',
              size: 'card-md',
              placeholder: 'Search..',
              value: filterItem.name,
              action: changeFilterItem,
            }
          ]}
          init={initFilterItem}
        />
      </div>
      <div className='card-list'>
        {hotelListItems.length > 0 ? hotelListItems.map((hotel, index) => (
          <div key={index} className='card-wrap' onClick={() => selectHotel(hotel.id)}>
            <div className='card-img'>
              {hotel.hotel_logo ? (
                <img src={hotel.hotel_logo} alt='hotel-img'/>
              ) : (
                <FontAwesomeIcon icon={faHotel}/>
              )}
            </div>
            <div className='card-body'>
              <p className='card-body-title'>{hotel.name}</p>
              <p className='card-body-text'>
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{padding:'0 13px 0 1px'}}/>
                {hotel.address || '-'}
              </p>
              <p className='card-body-text'>
                <FontAwesomeIcon icon={faBuilding} style={{padding:'0 12px 0 0'}}/>
                {`${hotel.building_counts || '0'} ${t('description.building_count')} [ ${hotel.room_counts || '0'} ${t('description.room_count')} ]`}
              </p>
            </div>
            <div className='card-footer'>
              <small className='card-text-muted'>{staffRoleFormatter(hotel.role)}</small>
            </div>
          </div>
        )) : (
          <div className='card-img no'>
            <FontAwesomeIcon icon={faExclamationCircle}/>
            <p>{t('error_message.no_data')}</p>
          </div>
        )}
        <Pagination
          total={hotelListTotal}
          index={currentPageNumber}
          limit={paginationItem.limit}
          indexChange={changePagination}
        />
      </div>
    </Fragment>
  );
};

export default HotelList;